/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    routes: [{
            // ======================
            // Full Layout
            // ======================
            path: '',
            component: () =>
                // eslint-disable-next-line
                import ('./layout/full/MainContainer.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            props: true,
            children: [{
                    path: '/',
                    redirect: '/login'
                },
                {
                    path: '/nt',
                    redirect: '/overview'
                }, {
                    path: '/sensordashboard',
                    name: 'SensorDashboard',
                    index: 2,
                    component: () =>
                        import ('./views/components/Page/SensorDashboard.vue'),
                    props: true
                }, {
                    path: '/sensorpage',
                    name: 'SensorPage',
                    index: 3,
                    component: () =>
                        import ('./views/components/Page/Subpage/SensorPage.vue'),
                    props: true
                }, {
                    path: '/sensoralert',
                    name: 'SensorAlert',
                    index: 4,
                    component: () =>
                        import ('./views/components/Page/Subpage/SensorAlert.vue'),
                    props: true
                }, {
                    path: '/overview',
                    name: 'Overview',
                    index: 5,
                    component: () =>
                        import ('./views/components/Page/Overview.vue')
                }, {
                    path: '/action',
                    name: 'Action',
                    index: 6,
                    component: () =>
                        import ('./views/components/Page/Action.vue')
                }, {
                    path: '/actionlist',
                    name: 'ActionList',
                    index: 7,
                    component: () =>
                        import ('./views/components/dashboard/Alert/ActionList.vue'),
                    props: true
                }, {
                    path: '/createaction',
                    name: 'CreateAction',
                    index: 8,
                    component: () =>
                        import ('./views/components/Page/Subpage/CreateAction.vue')
                }, {
                    path: '/map',
                    name: 'Map',
                    index: 9,
                    component: () =>
                        import ('./views/components/Page/Map.vue')
                }, {
                    path: '/overviewstate',
                    name: 'OverviewState',
                    index: 10,
                    component: () =>
                        import ('./views/components/dashboard/Overview/OverviewState.vue')
                }, {
                    path: '/network',
                    name: 'Network',
                    index: 11,
                    component: () =>
                        import ('./views/components/Page/Network.vue')
                }, {
                    path: '/networklist',
                    name: 'NetworkList',
                    index: 12,
                    component: () =>
                        import ('./views/components/dashboard/Network/NetworkList.vue')
                }, {
                    path: '/viewnetwork',
                    name: 'ViewNetwork',
                    index: 13,
                    component: () =>
                        import ('./views/components/Page/Subpage/ViewNetwork.vue'),
                    props: true
                }, {
                    path: '/createnetwork',
                    name: 'CreateNetwork',
                    index: 14,
                    component: () =>
                        import ('./views/components/Page/Subpage/CreateNetwork.vue')
                }, {
                    path: '/adddevice',
                    name: 'AddDevice',
                    index: 15,
                    component: () =>
                        import ('./views/components/Page/Subpage/AddDevice.vue'),
                    props: true
                }, {
                    path: '/editnetwork',
                    name: 'EditNetwork',
                    index: 16,
                    component: () =>
                        import ('./views/components/Page/Subpage/EditNetwork.vue')
                }, {
                    path: '/state',
                    name: 'State',
                    index: 17,
                    component: () =>
                        import ('./views/components/dashboard/Sensor/State.vue'),
                    props: true
                }, {
                    path: '/alertstate',
                    name: 'AlertState',
                    index: 18,
                    component: () =>
                        import ('./views/components/dashboard/Sensor/AlertState.vue'),
                    props: true
                }, {
                    path: '/addgateway',
                    name: 'AddGateway',
                    index: 19,
                    component: () =>
                        import ('./views/components/Page/Subpage/AddGateway.vue'),
                    props: true
                }, {
                    path: '/activestate',
                    name: 'ActiveState',
                    index: 20,
                    component: () =>
                        import ('./views/components/dashboard/Overview/ActiveState.vue'),
                    props: true
                }, {
                    path: '/shownetwork',
                    name: 'ShowNetwork',
                    index: 21,
                    component: () =>
                        import ('./views/components/dashboard/Overview/ShowNetwork.vue'),
                    props: true
                }, {
                    path: '/lastsensorstate',
                    name: 'LastSensorState',
                    index: 22,
                    component: () =>
                        import ('./views/components/dashboard/Overview/LastSensorState.vue'),
                    props: true
                }, {
                    path: '/login',
                    name: 'Login',
                    index: 23,
                    component: () =>
                        import ('./views/components/Page/Login.vue'),
                    props: true
                }, {
                    path: '/alertlist',
                    name: 'alertlist',
                    index: 24,
                    component: () =>
                        import ('./views/components/dashboard/Overview/AlertList.vue'),
                    props: true
                }, {
                    path: '/register',
                    name: 'Register',
                    index: 25,
                    component: () =>
                        import ('./views/components/Page/Register.vue'),
                    props: true
                }, {
                    path: '/sensor',
                    name: 'Sensor',
                    index: 26,
                    component: () =>
                        import ('./views/components/Page/Sensor.vue'),
                    props: true
                }, {
                    path: '/gateway',
                    name: 'Gateway',
                    index: 27,
                    component: () =>
                        import ('./views/components/Page/Gateway.vue'),
                    props: true
                }, {
                    path: '/report',
                    name: 'Report',
                    index: 28,
                    component: () =>
                        import ('./views/components/Page/Report.vue'),
                    props: true
                }, {
                    path: '/location',
                    name: 'Location',
                    index: 29,
                    component: () =>
                        import ('./views/components/Page/Location.vue'),
                    props: true
                }, {
                    path: '/locationsetting',
                    name: 'LocationSetting',
                    index: 30,
                    component: () =>
                        import ('./views/components/Page/LocationSetting.vue'),
                    props: true
                }, {
                    path: '/camera',
                    name: 'Camera',
                    index: 31,
                    component: () =>
                        import ('./views/components/Page/Camera.vue'),
                    props: true
                }, {
                    path: '/user',
                    name: 'User',
                    index: 32,
                    component: () =>
                        import ('./views/components/Page/User.vue'),
                    props: true
                }, {
                    path: '/permissionsetting',
                    name: 'PermissionSetting',
                    index: 33,
                    component: () =>
                        import ('./views/components/Page/Subpage/PermissionSetting.vue'),
                    props: true
                }, {
                    path: '/setting',
                    name: 'Setting',
                    index: 34,
                    component: () =>
                        import ('./views/components/Page/Setting.vue'),
                    props: true
                }, {
                    path: '/controls',
                    name: 'Control',
                    index: 35,
                    component: () =>
                        import ('./views/components/dashboard/Sensor/Control.vue'),
                    props: true
                }, {
                    path: '/historylog',
                    name: 'HistoryLog',
                    index: 36,
                    component: () =>
                        import ('./views/components/Page/HistoryLog.vue'),
                    props: true
                }, {
                    path: '/form',
                    name: 'Form',
                    index: 37,
                    component: () =>
                        import ('./views/components/Page/Form.vue'),
                    props: true
                }, {
                    path: '/workorder',
                    name: 'WorkOrder',
                    index: 38,
                    component: () =>
                        import ('./views/components/Page/WorkOrder.vue'),
                    props: true
                }, {
                    path: '/workstatus',
                    name: 'WorkStatus',
                    index: 39,
                    component: () =>
                        import ('./views/components/Page/WorkStatus.vue'),
                    props: true
                }, {
                    path: '/permission',
                    name: 'Permission',
                    index: 40,
                    component: () =>
                        import ('./views/components/Page/Permission.vue'),
                    props: true
                }, {
                    path: '/Test',
                    name: 'Test',
                    index: 41,
                    component: () =>
                        import ('./views/components/Page/Test.vue')
                }, {
                    path: '/Test2',
                    name: 'Test2',
                    index: 42,
                    component: () =>
                        import ('./views/components/Page/Test2.vue')
                }, {
                    path: '/WorkTemplate',
                    name: 'WorkTemplate',
                    index: 43,
                    component: () =>
                        import ('./views/components/Page/WorkTemplate.vue')
                }, {
                    path: '/App',
                    name: 'App',
                    index: 44,
                    component: () =>
                        import ('./App.vue')
                }, {
                    path: '/Alert',
                    name: 'Alert',
                    index: 45,
                    component: () =>
                        import ('./views/components/Page/Alert.vue')
                },
                {
                    path: '/ViewAlert',
                    name: 'ViewAlert',
                    index: 46,
                    component: () =>
                        import ('./views/components/Page/Subpage/ViewAlert.vue')
                },
                {
                    path: '/Test6',
                    name: 'Test6',
                    index: 47,
                    component: () =>
                        import ('./views/components/Page/Test6.vue')
                },
                {
                    path: '/login2',
                    name: 'Login2',
                    index: 48,
                    component: () =>
                        import ('./views/components/Page/login2.vue'),
                    props: true
                },
                {
                    path: '/ViewGateway',
                    name: 'ViewGateway',
                    index: 49,
                    component: () =>
                        import ('./views/components/Page/Subpage/ViewGateway.vue'),
                    props: true
                },
                {
                    path: '/WorkRequests',
                    name: 'WorkRequests',
                    index: 50,
                    component: () =>
                        import ('./views/components/Page/WorkRequests.vue'),
                    props: true
                },
                {
                    path: '/Resetpassword',
                    name: 'Resetpassword',
                    index: 51,
                    component: () =>
                        import ('./views/components/Page/Resetpassword.vue'),
                    props: true
                },
                {
                    path: '/indoortracking',
                    name: 'Indoortracking',
                    index: 52,
                    component: () =>
                        import ('./views/components/Page/indoortracking.vue'),
                    props: true
                },
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    index: 53,
                    component: () =>
                        import ('./views/components/Page/Dashboard.vue'),
                    props: true
                },
                {
                    path: '/Resetpassword1',
                    name: 'Resetpassword1',
                    index: 54,
                    component: () =>
                        import ('./views/components/Page/Resetpassword1.vue'),
                    props: true
                },
                {
                    path: '/setupWorkRequests',
                    name: 'setupWorkRequests',
                    index: 50,
                    component: () =>
                        import ('./views/components/Page/SetupWorkRequests.vue'),
                    props: true
                },
                {
                    path: '/test3',
                    name: 'test3',
                    index: 47,
                    component: () =>
                        import ('./views/components/Page/test3.vue')
                },
            ]
        },
        // Redirect to starterkit page, if no match found
        {
            path: '*',
            redirect: '/starterkit'
        }
    ]
})

router.beforeEach((to, from, next) => {
        // console.log(to)
        // console.log(Vue.prototype.$session.get('token'))
        if (to.name == 'Overview' && Vue.prototype.$session.get('token') == 'tmY8gRUIj9YOLwN5') {
            Vue.prototype.$session.set('nwname', 'All Network')
            Vue.prototype.$session.set('name', 'Light Control Sensor')
            Vue.prototype.$session.set('nwid', '65')
            Vue.prototype.$session.set('sensorid', '000001')
            Vue.prototype.$session.set('gatewayid', '000001')
            Vue.prototype.$session.set('type', 'control')
            next({
                name: 'SensorDashboard',
                params: {
                    nwname: 'All Network',
                    nwid: '65',
                    sensorid: '000001',
                    gatewayid: '000001',
                    type: 'control'
                }
            })
        }
        if (to.name == 'Resetpassword') {
            next()
        } else if ((to.name !== 'Login' && to.name !== 'Register' && to.name !== 'Login2') && !Vue.prototype.$session.get('token')) {
            next({ name: 'Login' })
        } else {
            next()
        }
    })
    // 
export default router